// extracted by mini-css-extract-plugin
export default {"article_container":"articleMenu_article_container__H9eeQ","btn":"articleMenu_btn__PLgux","color_span":"articleMenu_color_span__RLsms"};